<c-modal #checkOutDetailModal backdrop="static" size="lg" visible='true' id="checkOutDetailModal">
  <c-modal-header>
      <h4 class="modal-title">{{ title }}</h4>
      <button [cModalToggle]="checkOutDetailModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
  </c-modal-header>
  <c-modal-body>
      <c-row>
        <form cForm class="row g-12" [formGroup]="checkOutDetailForm">
          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>{{ "Check In Details" | translate }}</c-card-header>
                <c-card-body>
                  <c-row [xs]="1" [xl]="2">
                    <c-col>
                      <label cLabel>Date: {{ selectedCheckOut.checkIn.date | date: "yyyy-MM-dd" }}</label>
                    </c-col>
                    <c-col>
                      <label cLabel>Branch Name: {{ selectedCheckOut.checkIn.branch.name }}</label>
                    </c-col>
                    <c-col>
                      <label cLabel>Pets:</label>
                      <ul
                          [horizontal]="true"
                          cListGroup
                          class="mb-2">
                        <li cListGroupItem *ngFor="let pet of selectedCheckOut.checkIn.pets;">
                          {{pet.name}}
                        </li>
                      </ul>
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>
          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>{{ "Check Out Date" | translate }}</c-card-header>
                <c-card-body>
                  <c-row [xs]="1" [xl]="2">
                    <c-col [md]="12">
                      <label cLabel for="date">Date</label>
                      <input cFormControl id="date" type="date" formControlName="date" />
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>

          <!-- Charges -->
          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>{{ "Service Charges" | translate }}</c-card-header>
                <c-card-body>
                  <c-row>
                    <c-col [xs]>
                      <c-row>
                        <c-col [md]="4">
                          <label cLabel for="petName">Pet</label>
                          <c-input-group>
                            <input aria-label="pet"
                              placeholder="Select Pet"
                              formControlName="petName" name="petName" type="text" id="petName"
                              cFormControl
                              [typeaheadOptionsLimit]="10"
                              [typeaheadLatinize]="true"
                              [typeahead]="checkOutPets"
                              typeaheadOptionField="name"
                              [typeaheadMinLength]="0"
                              (typeaheadOnSelect)="onSelectPet($event)"
                            />
                            <!-- <button cButton color="secondary" type="button" variant="outline">
                              Add
                            </button> -->
                          </c-input-group>
                        </c-col>
                        <c-col [md]="3">
                          <label cLabel for="itemName">Item</label>
                          <c-input-group>
                            <input aria-label="service"
                              placeholder="Add service"
                              formControlName="itemName" name="itemName" type="text" id="itemName"
                              cFormControl
                              placeholder="Add Item"
                              [typeaheadOptionsLimit]="10"
                              [typeaheadLatinize]="true"
                              [typeahead]="availableItems"
                              typeaheadOptionField="name"
                              [typeaheadMinLength]="0"
                              (typeaheadOnSelect)="onSelectItem($event)"
                            />
                            <!-- <button cButton color="secondary" type="button" variant="outline">
                              Add
                            </button> -->
                          </c-input-group>
                        </c-col>
                        <c-col [md]="2">
                          <label cLabel for="unitPrice">Unit Price</label>
                          <input cFormControl formControlName="unitPrice" id="unitPrice" type="number" />
                        </c-col>
                        <c-col [md]="3">
                          <label cLabel for="quantity">Quantity</label>
                          <c-input-group>
                            <input cFormControl formControlName="quantity" id="quantity" type="number" />
                            <button *ngIf="hasEditPermission || hasAddPermission" cButton color="secondary" type="button" variant="outline" (click)="saveCheckOutItem()">
                              Save
                            </button>
                          </c-input-group>
                        </c-col>
                      </c-row>
                      <c-row>

                            <table cTable hover>
                              <thead>
                              <tr>
                                <th scope="col">Pet</th>
                                <th scope="col">Item</th>
                                <th scope="col">Unit Price</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Total</th>
                                <th scope="col">Action</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let checkOutItem of checkOutItems">
                                <td>{{checkOutItem.pet.name}}</td>
                                <td>{{checkOutItem.itemName}}</td>
                                <td>{{checkOutItem.unitPrice | number:'1.2-2'}}</td>
                                <td>{{checkOutItem.quantity | number}}</td>
                                <td>{{checkOutItem.unitPrice * checkOutItem.quantity | number:'1.2-2'}}</td>
                                <td>
                                  <button *ngIf="(!isNew && hasEditPermission) || (isNew && hasAddPermission)" cButton type="button" color="info" (click)="editCheckOutItem(checkOutItem)" class="mx-2">Edit</button>
                                  <button *ngIf="(!isNew && hasEditPermission) || (isNew && hasAddPermission)" cButton type="button" color="danger" (click)="removeCheckOutItem(checkOutItem)">Remove</button>
                                </td>
                              </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>Subtotal</td>
                                  <td>
                                    <strong>{{ subTotalAmount |  number:'1.2-2' }}</strong>
                                  </td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>Discount (%)</td>
                                  <td>
                                    <!-- <input cFormControl [ngModel]="discount" (ngModelChange)="calculateTotal()" id="discount" type="number" placeholder="Discount" /> -->
                                    <input cFormControl formControlName="discount" id="discount" type="number" placeholder="Discount" />
                                  </td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>Total</td>
                                  <td>
                                    {{ totalAmount | number:'1.2-2' }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tfoot>
                            </table>


                      </c-row>
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>
        </form>
      </c-row>
  </c-modal-body>
  <c-modal-footer>
    <button type="button" cButton color="secondary" (click)="closeModal()">Close</button>
    <button *ngIf="(!isNew && hasEditPermission) || (isNew && hasAddPermission)" type="button" cButton color="primary" (click)="saveCheckOutDetail()">
      <c-spinner aria-hidden="true" size="sm" hidden="!isSavingCheckOut"></c-spinner>Submit
    </button>
    <button *ngIf="hasAddInvoicePermission" type="button" cButton color="info" (click)="createInvoice()">
      <c-spinner aria-hidden="true" size="sm" hidden="!isCreatingInvoice"></c-spinner>Create Invoice
    </button>
  </c-modal-footer>
</c-modal>
